import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";

import { Button, Typography } from "ui-library/atoms";
import { ContentBox } from "ui-library/layouts";
import { DataTable } from "ui-library/modules";

import i18n from "core/i18n";
import modal from "core/modal";
import { DocumentLink } from "containers/DocumentLink";
import { useHasRole } from "core/hooks";
import { Roles } from "enums";
import { vehicleChangeApi } from "serverApi";
import { FileItem } from "types";
import { MODAL_UPLOAD_DOCUMENT, SECTION_MARGIN } from "../../constants";
import { VehicleCancellationFormValues } from "../../types";

import { FileItemsStatus } from "../components";
import { RequestDocumentUploadModal } from "../modal";

export const PhysicalSignRequestDocumentSection: FC = () => {
    const { t } = i18n.useTranslation();
    const dispatch = useDispatch();

    const isAuthenticated = useHasRole(Roles.AUTHENTICATED);

    const { getValues, watch } = useFormContext<VehicleCancellationFormValues>();
    const changeId = getValues("changeSheetId");
    const uploadedSignature: FileItem[] = watch("signature") || [];

    const downloadUrl = () => vehicleChangeApi.getDocumentToSignDownloadUrl(changeId);

    const openUploadDocumentDialog = () => {
        dispatch(modal.openModalForm(MODAL_UPLOAD_DOCUMENT));
    };

    const physicalSignatureColumns = [
        {
            field: "label",
            headerName: `${t("change.mandatoryAttachment")}`,
            flex: 3.5,
            sortable: false,
            renderCell: () => {
                return isAuthenticated ? (
                    <DocumentLink fileName={t("change.signature.downloadDocumentToSign")} fileUrl={downloadUrl()} />
                ) : (
                    t("change.signature.signedRequest")
                );
            },
        },
        {
            field: "id",
            headerName: `${t("common.insertDocument")}`,
            flex: 1,
            sortable: false,
            renderCell: () => {
                return <Button onClick={() => openUploadDocumentDialog()} rounded variant="text" color="blue" startIcon={"file-plus"} />;
            },
        },
        {
            field: "status",
            headerName: `${t("vehicle.change.subject.documents.attachmentStatus")}`,
            flex: 0.5,
            sortable: false,
            renderCell: () => <FileItemsStatus fileItems={uploadedSignature} />,
        },
    ];

    return (
        <>
            <ContentBox fullWidth textAlign={"center"} mt={SECTION_MARGIN}>
                <Typography variant="h3">{t("change.signature.requestSignatures")}</Typography>
            </ContentBox>
            <ContentBox fullWidth textAlign={"center"}>
                <Typography>{t("change.signature.infoText")}</Typography>
            </ContentBox>

            <ContentBox fullWidth>
                <DataTable
                    disableColumnReorder
                    getRowId={(row) => row.id}
                    pageSize={10}
                    rows={[{ label: "sign", id: "123", status: "sign" }]}
                    columns={physicalSignatureColumns}
                    hideFooter
                />
            </ContentBox>

            {/* Modals */}
            <RequestDocumentUploadModal />
        </>
    );
};
